<template>
  <div>
    <custom-label v-if="label" :item-field-name="label" />
    <v-select
      dense
      :prepend-inner-icon="icon"
      hide-details="auto"
      :placeholder="placeholder"
      :background-color="$vuetify.theme.themes.light.inputBackgroundColor"
      filled
      v-bind="$attrs"
      v-on="$listeners"
      rounded
    >
      <!-- Pass through all slots -->
      <template v-for="(_, name) in $scopedSlots" v-slot:[name]="props">
        <slot :name="name" v-bind="props" />
      </template>
    </v-select>
  </div>
</template>

<script>
import customLabel from '@/components/customFormLabel/customLabel';
export default {
  name: 'FletrixSelect',
  components: {
    customLabel,
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
};
</script>
